import { useState } from "react";
import { Send, CornerDownRight } from "lucide-react";
import { toast } from "sonner";

export const formatDate = (iso) => {
  try {
    return new Date(iso).toLocaleString("it-IT", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return iso;
  }
};

export const ReplySent = ({ message }) => (
  <div
    className="mt-4 ml-4 md:ml-8 p-4 md:p-5 bg-paper border border-ink-200 rounded-sm"
    data-testid={`admin-reply-sent-${message.id}`}
  >
    <div className="flex items-center gap-2 overline mb-2">
      <CornerDownRight className="w-3.5 h-3.5" strokeWidth={1.6} />
      Risposta inviata · {formatDate(message.replied_at)}
    </div>
    <p className="text-[13px] md:text-[14px] text-ink-700 leading-relaxed whitespace-pre-wrap">
      {message.reply_text}
    </p>
  </div>
);

export const ReplyForm = ({ message, onReply, onClose }) => {
  const [text, setText] = useState("");
  const [sending, setSending] = useState(false);

  const send = async () => {
    if (!text.trim()) {
      toast.error("Scrivi un testo prima di inviare");
      return;
    }
    setSending(true);
    try {
      const r = await onReply(message.id, text.trim());
      toast.success(
        r.email_sent
          ? `Risposta inviata a ${message.email}`
          : "Risposta salvata, ma l'invio email non è riuscito"
      );
      onClose();
    } catch {
      toast.error("Errore durante l'invio della risposta");
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="mt-4 ml-4 md:ml-8" data-testid={`admin-reply-form-${message.id}`}>
      <textarea
        rows={4}
        value={text}
        onChange={(e) => setText(e.target.value)}
        data-testid={`admin-reply-text-${message.id}`}
        className="w-full bg-white border border-ink-200 focus:border-ink-900 outline-none p-4 text-[14px] leading-relaxed transition-colors resize-none rounded-sm"
        placeholder={`Scrivi la risposta per ${message.name}…`}
      />
      <div className="mt-3 flex items-center gap-3">
        <button
          onClick={send}
          disabled={sending}
          data-testid={`admin-reply-send-${message.id}`}
          className="btn-pill h-10 disabled:opacity-60"
        >
          {sending ? "Invio…" : "Invia risposta"}
          <Send className="w-3.5 h-3.5" strokeWidth={1.6} />
        </button>
        <button
          onClick={onClose}
          className="text-[11px] font-mono tracking-[0.14em] uppercase text-ink-500 hover:text-ink-900 transition-colors"
        >
          Annulla
        </button>
      </div>
      <p className="mt-2 text-[11px] text-ink-500">
        La risposta arriverà a {message.email} da no-reply@mysteriousstew.com.
      </p>
    </div>
  );
};
